module.exports = __webpack_public_path__ + "static/media/seminary.a2ab17a1.png";